namespace Ir.Components.Filters.MetricFilter {

    interface IMetricFilterViewModel {
        filter: Filter;
        startNumberBoxSettings: DevExpress.ui.dxNumberBox.Properties;
        endNumberBoxSettings: DevExpress.ui.dxNumberBox.Properties;
        checkBoxSettings: DevExpress.ui.dxCheckBox.Properties;

        isBetween: KnockoutComputed<boolean>
        updateDisplayText: Function;
    }
    export function getViewModel(this: IMetricFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        this.isBetween = ko.computed(function () {
            return self.filter.conditionType() === FilterConditionTypeEnum.Between || self.filter.conditionType() === FilterConditionTypeEnum.NotBetween;
        });

        this.checkBoxSettings = {
            value: this.filter.metricFilterAbsolute as any,
            text: "Absolute",
            onValueChanged(data) {
                self.filter.metricFilterAbsolute(data.value);
                if (data.value) {
                    if (self.filter.startCondition()) {
                        self.filter.startCondition(self.filter.startCondition().replace("-", ""));
                    }

                    if (self.isBetween()) {
                        if (self.filter.endCondition()) {
                            self.filter.endCondition(self.filter.endCondition().replace("-", ""));
                        }
                    }
                }

                self.updateDisplayText();
                self.filter.publish();
            }
        }

        let conditionTypeOptions = this.filter.getConditionTypeOptions();
        this.updateDisplayText = function () {
            let icon = (conditionTypeOptions.find(function (x) { return (x as any).id === self.filter.conditionType(); }) as any).icon;
            let absolute = self.filter.metricFilterAbsolute() ? "|" : "";
            let startCondition = self.filter.startCondition();
            let endValue = "";
            if (self.filter.conditionType() === FilterConditionTypeEnum.Between || self.filter.conditionType() === FilterConditionTypeEnum.NotBetween) {
                endValue = ` And ${absolute}${self.filter.endCondition()}${absolute}`;
            }

            if (startCondition !== null && startCondition !== undefined && startCondition != "") {
                self.filter.startDisplayCondition(`${icon} ${absolute}${startCondition}${absolute}${endValue}`);
            }
            else {
                self.filter.startDisplayCondition("");
            }
        };
        this.updateDisplayText();
        this.filter.conditionType.subscribe(function () {
            if (self.filter.isMetric()) {
                if (self.filter.conditionType() !== FilterConditionTypeEnum.Between && self.filter.conditionType() !== FilterConditionTypeEnum.NotBetween) {
                    self.filter.endCondition("");
                }

                self.updateDisplayText();
            }
        });

        this.startNumberBoxSettings = {
            disabled: this.filter.readOnly as any,
            value: this.filter.startCondition as any,
            showSpinButtons: isMobile() ? false : true,
            width: 80,
            onInput(e) {
                workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
            },
            onValueChanged(data) {
                if (data.previousValue !== data.value) {
                    let value = data.value !== null && data.value !== undefined ? `${data.value}` : "";
                    if (self.filter.metricFilterAbsolute()) {
                        value = value.replace("-", "");
                    }

                    self.filter.startCondition(value)

                    self.updateDisplayText();
                    self.filter.publish();
                }
            }
        }

        this.endNumberBoxSettings = {
            disabled: this.filter.readOnly as any,
            value: this.filter.endCondition as any,
            showSpinButtons: isMobile() ? false : true,
            width: 80,
            onInput(e) {
                workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
            },
            onValueChanged(data) {
                if (data.previousValue !== data.value) {
                    let value = data.value !== null && data.value !== undefined ? `${data.value}` : "";
                    if (self.filter.metricFilterAbsolute()) {
                        value = value.replace("-", "");
                    }

                    self.filter.endCondition(value)

                    self.updateDisplayText();
                    self.filter.publish();
                }
            }
        }

        this.filter.clearFilter = function () {
            self.filter.startCondition("");

            if (self.isBetween()) {
                self.filter.endCondition("");
            }
        }
    }
}